import request from 'helpers/request';
import { EVENTS_URL } from '../../constants/api';

export const getEvents = (params: any): Promise<string> =>
    request.get(EVENTS_URL, { params });
